import React from 'react';
import { Box, Typography, Button } from '@mui/material';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Uncaught error caught by ErrorBoundary:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: 3,
            backgroundColor: '#f8f9fa',
            textAlign: 'center'
          }}
        >
          <Box
            sx={{
              backgroundColor: '#ffffff',
              borderRadius: '12px',
              padding: { xs: '32px 24px', sm: '40px 48px' },
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
              maxWidth: '460px',
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                color: '#02140A',
                marginBottom: 1.5
              }}
            >
              Something went wrong
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: '#666666',
                marginBottom: 3,
                lineHeight: 1.6
              }}
            >
              An unexpected error occurred. Please refresh the page to continue.
            </Typography>
            <Button
              variant="contained"
              onClick={this.handleReload}
              sx={{
                backgroundColor: '#02140A',
                color: '#ffffff',
                fontWeight: 600,
                padding: '10px 28px',
                borderRadius: '8px',
                textTransform: 'none',
                fontSize: '15px',
                '&:hover': {
                  backgroundColor: '#021209'
                }
              }}
            >
              Refresh Page
            </Button>
          </Box>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
